export { MyAccountLinkController as MyAccountLink } from './my-account-link-controller';
